<!--  

APRESENTA O EMAIL COM O CORPO, ANEXOS E BOTOES DE RESPOSDER E ENCAMINHAR

-->


<script>

import axios from 'axios'
import { SysVars } from '../main';
import apiCrm from '../api/api-crm.js'
import CrmEmailDestinatarios from './crm-email-destinatarios'
import { formatDataHoraExtenso } from '../shared/utils'

export default {

    props: {
      codemail: '',
      negocio: Object,
      pessoa: Object,
    },

    data () {
        return {
            editing: false,
            metadata: this.$store.getters.getEntities.metadata,


            bodyContent: null,
            bodyContentCopy: null,
            editor: null,

            config: {
                // { [module]: boolean (set true to hide) }
                hideModules: { "bold": true },
                iconOverrides: { "bold": "<i class='your-custom-icon'></i>" },
                image: {
                    uploadURL: "/api/myEndpoint",
                    dropzoneOptions: {}
                },
                maxHeight: "500px",
                forcePlainTextOnPaste: true,
                locale: 'pt'
            },

            upaloading: false,

            editingEmail: null,
            editingToList: [],
            editingCCList: [],
            editingBCCList: [],
            editingSubject: null,
            editingAttachments: [],
            sendMode: null,
            editingEnc: false,
            editingRe: false,

            selectedFile: null,

            codtempl: null,

            templateOptions: null,

        }
    },

    components: {
        CrmEmailDestinatarios, // EditorContent,
    },

    computed: {
        usuarionome: function () {
            return this.$store.getters.getEnv.usuarionome
        },

        templEmailList: function () {
            return this.$store.getters.getTemplEmailList
        },

        email: function () {
            if (this.$store.getters.getEmailCrm)
              return this.$store.getters.getEmailCrm
            else  
              return null
        },

        destinatarios () {
            return {
                toList: this.editingToList,
                ccList: this.editingCCist,
                bccList: this.editingBCCList,
            }
        },

        fromAddress () {
            let addr = 'crm.mail.nb+' + this.$store.getters.getSessao.urlstring
            if (this.editingEmail.link_codnegocio)
               addr = addr + '+deal' + this.editingEmail.link_codnegocio
            return { email: addr + '@gmail.com', nome: this.usuarionome }
        },

    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    filters: {

    },

    methods: {
        async loadTemplates () {
            await this.$store.dispatch('loadTemplEmail', {})

            this.templateOptions = []
            for (var x = 0; x < this.$store.getters.getTemplEmailList.length; x++) {
                this.templateOptions.push({ id: this.$store.getters.getTemplEmailList[x].codtempl, text: this.$store.getters.getTemplEmailList[x].descricao })
            }
        },

        template () {
            //CARREGA O TEMPLATE SELECIONADO PELO USUARIO
            console.log('teste1')
            if (!this.codtempl)
              return

            let self = this
            
            let template = this.templEmailList.filter( function (obj) { return obj.codtempl == self.codtempl })
            this.bodyContent = template[0].body_content
            if (this.sendMode == 'new') {
              this.editingSubject = template[0].subject 
            }
        },

        async loadData (codemail) {
            //carrega o email do servidor
            let cod = codemail
            if (!cod)
              cod = this.codemail
            await this.$store.dispatch('loadEmailCrm', { id: cod } )

            //carrega o corpo do email armazenado no S3
            if (this.email.bodyurl) {
                let self = this
                axios.get(this.email.bodyurl, 
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Access-Control-Allow-Origin': '*',
                            'Access-Control-Allow-Headers': 'content-type',
                        }
                    }
                ).then((data) => { self.bodyContent = data.data })
            }

            if (this.email.visualizado == 'N' && this.email.inbox == 'S') 
              this.apiEmailLido(this.email.codemail)

            this.$nextTick(function () {
                    jQuery('[data-toggle="tooltip"]').tooltip()
                })
            
            this.show = 'collapsing'
        },

        handleResponder () {
            if (!this.editingEmail)
              this.editingEmail = {}
            
            this.editingToList = []
            this.editingCCList = []

            for (var x = 0; x < this.email.from_list.length; x++) {
                if (this.email.from_list[x].email)
                    this.editingToList.push({ email: this.email.from_list[x].email, nome: this.email.from_list[x].nome, label: this.email.from_list[x].nome + ' ' + this.email.from_list[x].email })
                else 
                    this.editingToList.push({ email: this.email.from_list[x], nome: '', label: this.email.from_list[x] })
            }

            if (this.email.cc_list) {
                for (var x = 0; x < this.email.cc_list.length; x++) {
                    if (this.email.cc_list[x].email)
                        this.editingCCList.push({ email: this.email.cc_list[x].email, nome: this.email.cc_list[x].nome, label: this.email.cc_list[x].nome + ' ' + this.email.cc_list[x].email })
                    else 
                        this.editingCCList.push({ email: this.email.cc_list[x], nome: '', label: this.email.cc_list[x] })
                }
            }

            this.editingEmail.link_codnegocio = this.email.link_codnegocio
            this.editingSubject = 'Re: ' + this.email.subject
            this.editingAttachments = []

            this.editingRe = true
            this.editingEnc = false
            this.sendMode = 'reply'

            this.addReplyBlock()
            this.editing = true

            this.$nextTick(function () {
                this.$refs.destinatarios.focus()
            })

        },

        handleEncaminhar () {
            if (!this.editingEmail)
              this.editingEmail = {}

            this.editingToList = []
            this.editingCCList = []

            this.editingEmail.link_codnegocio = this.email.link_codnegocio
            this.editingSubject = 'Enc: ' + this.email.subject
            this.editingAttachments = this.email.attachments

            this.editingEnc = true
            this.editingRe = false
            this.sendMode = 'forward'

            this.addReplyBlock()
            this.editing = true

            this.$nextTick(function () {
                this.$refs.destinatarios.focus()
            })

            if (this.editingAttachments.length > 0)
              this.handleSalvar(false) //salva a mensagem quando esta possuir arquivos anexos 

        },

        handleRemoverAnexo (idx) {
            //REMOVE ANEXO DO EMAIL EM EDICAO
            this.$set(this.editingAttachments[idx], 'excluido', true)
            this.apiDeleteAnexo(this.editingAttachments[idx].coddoc)
        },

        addReplyBlock () {
            //ADICIONA O BLOCO DE RESPOSTA AO CORPO DO EMAIL

            if (!this.bodyContentCopy)
              this.bodyContentCopy = this.bodyContent
            else
              this.bodyContent = this.bodyContentCopy

            let data = formatDataHoraExtenso(this.email.data)
            let nome = ''
            let from = ''
            let to = ''
            let cc = ''

            if (this.email.from_list.length > 0) {
                if (this.email.from_list[0].email)
                    from = this.email.from_list[0].email
                else 
                    from = this.email.from_list[0]
            }

            for (var x = 0; x < this.email.to_list.length; x++) {
                if (to != '')
                  to = to + ', ' 
                if (this.email.to_list[x].email)
                    to = to + this.email.to_list[x].email
                else 
                    to = to + this.email.to_list[x]
            }
            to = 'To: ' + to

            if (this.email.cc_list.length > 0) {
                for (var x = 0; x < this.email.cc_list.length; x++) {
                    if (!cc)
                    cc = cc + ', ' 
                    if (this.email.cc_list[x].email)
                        cc = cc + this.email.cc_list[x].email
                    else 
                        cc = cc + this.email.cc_list[x]
                }
                cc = 'Cc: ' + cc
            }

            if (this.sendMode == 'reply')
                this.bodyContent = 
                '<br>'+
                '<div class="gmail_quote">' + 
                    '<div dir="ltr" class="gmail_attr">Em {{data}}, {{nome}} &lt;{{from}}&gt; escreveu:<br></div>' +
                    '<blockquote class="gmail_quote" style="margin: 0px 0px 0px 0.8ex; border-left: 1px solid rgb(204, 204, 204); padding-left: 1ex;">' + 
                        this.bodyContent + 
                    '</blockquote>' +
                '</div>'
            else
                this.bodyContent = 
                '<br>'+
                '<blockquote data-type="forward">'+
                    '<div dir="ltr" class="gmail_attr">---------- Forwarded message ---------<br>'+
                    'De: <strong class="gmail_sendername" dir="auto">{{nome}}</strong> <span dir="auto">&lt;{{from}}&gt;</span><br>'+
                    'Date: {{data}}<br>Subject: {{subject}}<br>{{to}}<br>{{cc}}<br></div>'+
                    '<div>'+ 
                        this.bodyContent + 
                    '</div>'+ 
                '</blockquote>'
            
            this.bodyContent = this.bodyContent.replace('{{nome}}', nome)
            this.bodyContent = this.bodyContent.replace('{{data}}', data)
            this.bodyContent = this.bodyContent.replace('{{from}}', from)
            this.bodyContent = this.bodyContent.replace('{{to}}', to)
            this.bodyContent = this.bodyContent.replace('{{cc}}', cc)
            this.bodyContent = this.bodyContent.replace('{{subject}}', this.email.subject)
        },
        
        ////////////////////////////////// ANEXAR ARQUIVOS NO EMAIL
        /*
        emails encaminhados: quando há anexos, os anexos são copiados e vinculados ao novo email criado, então a rotina cria novos
        registros na tabela NBAPP.docs

        */
        
        handleAnexo () {
            this.$refs.file.value = ''            
            this.$refs.file.click()
        },

        handleAdicionarAnexo (event) {
            // if (event.target.files[0]['type']!=='image/jpeg' && event.target.files[0]['type']!=='image/png') {
            //     this.$erpToastError('Arquivo não permitido')
            //     return 
            // }

            this.selectedFile = event.target.files[0] //this.$refs.file.files[0]

            if (!this.editingEmail || !this.editingEmail.codemail) {
                // quando usuario anexar arquivo no email, deve checar se o email possui codigo, se nao, 
                //deve gravar a mensagem e depois anexar
                this.upaloading = true
                this.handleSalvar(false)
                return
            }

            let obj = {
                codemail: this.editingEmail.codemail,
                selectedFile: this.selectedFile
            }
            this.apiUploadAnexo(obj, this.callbackAdicionarAnexo)
        },

        callbackAdicionarAnexo (data) {
            this.editingAttachments.push( data )
        },





        //////////////////////////////////// ROTINAS SALVAR EMAIL RASCUNHO E ENVIAR EMAIL

        handleEnviar () {

            if (!this.$refs.destinatarios.isValid) {
                return
            }

            this.handleSalvar(true)

        },

        handleSalvar (enviar) {
            //salvar email

            if (!this.editingEmail)
              this.editingEmail = {}

            if (this.$refs.destinatarios) {
              this.$refs.destinatarios.isValid()
              let destinatarios = this.$refs.destinatarios.getDestinatarios
              this.editingEmail.to = destinatarios.toList
              this.editingEmail.cc = destinatarios.ccList
              this.editingEmail.bcc = destinatarios.bccList
            } else {
              this.editingEmail.to = []
              this.editingEmail.cc = []
              this.editingEmail.bcc = []
            }

            this.editingEmail.from = [ this.fromAddress ]
            this.editingEmail.subject = this.editingSubject
            if (this.bodyContent)
              this.editingEmail.body = this.bodyContent
            this.editingEmail.sendmode = this.sendMode

            if (this.codemail)
                this.editingEmail.replyto_codemail = this.codemail
            else
                this.editingEmail.replyto_codemail = null

            if (!enviar)
                this.editingEmail.draft = true
            else
                this.editingEmail.draft = false

            if (this.negocio) 
              this.editingEmail.link_codnegocio = this.negocio.codnegocio

            if (this.pessoa)
              this.editingEmail.link_codpessoa = this.pessoa.codpessoa

            this.emailPost(this.editingEmail, this.editingEmail.codemail, this.callbackSalvar)

        },

        callbackSalvar (email) {
            //EXECUTA APOS GRAVAR O EMAIL
            this.editingEmail.codemail = email.codemail

            if (!email)
              return
            
            if (email.enviado == 'S') {
                //email enviado, recarrega o email na tela
                this.editing = false
                this.loadData(email.codemail)
                this.$erpToastSuccess('E-mail enviado')
            }
            if (this.upaloading) {
                this.upaloading = false
                let obj = {
                    codemail: this.editingEmail.codemail,
                    selectedFile: this.selectedFile
                }
                this.apiUploadAnexo(obj, this.callbackAdicionarAnexo)
            }

            if (this.sendMode == 'new' && !this.editingEmail.draft) {
                this.$emit('closeform', email, true)
            }
        },

        handleCancelar () {
            this.$emit('closeform')
        },

        handleClose () {
            this.$emit('closeform', this.email)
        }

    },

    watch: {
        codtempl: function (value) {
            this.template()
        },

        bodyContent: function () {
            // this.editor = new Editor({
            //     content: this.bodyContent
            // })            
        }

    },

    created () {
        this.loadTemplates()

        if (this.codemail)
            this.loadData()
        else {
            this.sendMode = 'new'
            this.editingEmail = {}
            if (this.negocio) {
                this.editingEmail.link_codnegocio = this.negocio.codnegocio
                this.editingSubject = this.negocio.titulo
            }
            if (this.pessoa) {
                if (this.pessoa.emails && this.pessoa.emails.length > 0)
                    this.editingToList.push( { email: this.pessoa.emails[0].email, nome: this.pessoa.nome, label: this.pessoa.nome + ' ' + this.pessoa.emails[0].email } )
            }

            this.editing = true
            this.$nextTick(function () {
                this.$refs.destinatarios.focus()
            })
        }
    },

    beforeDestroy() {
        // this.editor.destroy()
    },
}

</script>

<template>
    <div>
        <!-- VISUALIZACAO DO EMAIL -->
        <div v-if="email && !editing" class="row mb-2 align-items-center">
            <div class="col-12">
                <v-button :link="true" icon="fa-compress" class="float-right" @click="handleClose"></v-button>
                <v-button :link="true" title="Encaminhar" icon="fa-mail-forward" class="float-left" @click="handleEncaminhar"></v-button>
                <v-button :link="true" title="Responder" icon="fa-mail-reply" class="float-left" @click="handleResponder"></v-button>
                <span class="lbl-list float-right"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ email.data | formatDataHoraExtenso }}</span>
                <span v-if="email.usuario_nome" class="lbl-list pr-3 mb-3"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> {{ email.usuario_nome }}</span>
            </div>
            <div class="col-12">
                <span class="lbl-list pr-3 mb-3">De </span>
                <span v-if="email.from_list.length > 0" class="data-list"><strong>{{ email.pessoa_nome }}</strong> {{ email.from_list[0].email }}</span>
            </div>
            <div class="col-12">
                <span class="lbl-list pr-2">Para </span>
                <span v-for="(to, index) in email.to_list" :key="index" class="data-list pr-2"><strong>{{ to.nome }}</strong> {{ to.email }}</span>
            </div>
            <div class="col-md-12">
                <span class="lbl-list pr-3">Assunto </span>
                <span class="data-list"><strong> {{ email.subject }} </strong> </span>
            </div>
            <div class="col-md-12" v-if="bodyContent">
                <div v-html="bodyContent"></div>
            </div>
            <div class="col-md-auto mt-2" v-for="(file, index) in email.attachments" :key="index">
                <div class="card p-2 attach-file" style="cursor: pointer" data-toggle="tooltip" data-placement="top" :title="file.filename">
                    <div class="w-100">
                        <a class="lbl-edit" :href="file.url"><i class="fa fa-paperclip pr-2 attach-icon" aria-hidden="true"></i> {{ file.filename }} </a>
                    </div>
                </div>
            </div>

        </div>
        
        <!-- EDICAO DO EMAIL -->
        <div v-if="email && editing" class="row mb-2 align-items-center">
            <div class="col-6">
                <span v-if="sendMode=='new'" class="lbl-deal-title">Novo E-mail</span>
                <span v-if="sendMode=='reply'" class="lbl-deal-title">Responder</span>
                <span v-if="sendMode=='forward'" class="lbl-deal-title">Encaminhar</span>
                <v-button :link="true" v-if="sendMode!='new'" title="Encaminhar" icon="fa-mail-forward" class="float-left" @click="handleEncaminhar"></v-button>
                <v-button :link="true" v-if="sendMode!='new'" title="Responder" icon="fa-mail-reply" class="float-left" @click="handleResponder"></v-button>
            </div>
            <div class="col-6">
                <v-button :link="true" icon="fa-compress" class="float-right" @click="handleClose"></v-button>
            </div>
            <div class="col-12">
                <crm-email-destinatarios ref="destinatarios" :destinatarios="destinatarios" url="crm/find/pessoa/email?text="></crm-email-destinatarios>
            </div>

            <form-field v-model="editingSubject" type="text" col="12" label="Assunto"></form-field>

            <div class="col-12">
                <wysiwyg v-model="bodyContent" />
            </div>

            <div class="col-12 mt-2">
                <div v-for="(file, index) in editingAttachments" :key="index">
                    <div class="data-list badge-email mr-2" v-if="!file.excluido" role="alert">
                        <button type="button" tabindex="1" class="close" data-dismiss="alert" @click="handleRemoverAnexo(index)">
                            x</button>
                        <label class="mt-1"><i class="fa fa-paperclip pr-2 attach-icon" aria-hidden="true"></i>{{ file.filename }}</label>
                    </div>
                </div>
            </div>

            <form-field v-if="templateOptions && templateOptions.length > 0" v-model="codtempl" type="select2static" col="6" label="Selecione um Template" :select-options="templateOptions"></form-field>

            <div class="col-12 mt-2">
                <v-button label="Anexar" icon="fa-paperclip" @click="handleAnexo"></v-button>
                <v-button label="Enviar" icon="fa-arrow-right" :success="true" @click="handleEnviar"></v-button>
                <v-button label="Cancelar" icon="" @click="handleCancelar"></v-button>
            </div>

            <input v-show="false" type="file" ref="file" accept="image/*" @change="handleAdicionarAnexo($event)">

        </div>
    </div>
</template>


<style scoped>

.attach-icon {
    font-size: 18px;
}

.attach-file {
    cursor: pointer;
}


.badge-email {
    display: inline-block;
    padding: 0 5px 0 5px;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    background: #fff;
    border: 1px solid;
    border-radius: 10px;
    border-color: #ebebeb;    
}

.badge-email:hover {
    background-color: #f7f7f7;
}

.close:hover, .close:focus {
    /* color: #000; */
    text-decoration: none;
    opacity: .75;
}

.close {
    float: right;
    font-size: 1.0rem;
    color: #c5c4c4; 
    opacity: 1;
    margin: 3px 5px 0px 5px;
}

</style>



// WEBPACK FOOTER //
// src/forms-crm/crm-email.vue